module.exports = __webpack_public_path__ + "img/4.67f236e6.png";